export default __webpack_public_path__ + "static/media/alvarofernandes.cd16e904.jpeg";